import {
  PAP_REFERRAL_COOKIE_NAME,
  REFERRAL_COOKIE_NAME,
  AFFILIATE_QUERY_PARAMS_EXPRESSION,
  PAP_QUERY_PARAM_EXPRESSION,
} from "@mm/constants/referrals";

const refs = [
  { re: AFFILIATE_QUERY_PARAMS_EXPRESSION, name: REFERRAL_COOKIE_NAME },
  { re: PAP_QUERY_PARAM_EXPRESSION, name: PAP_REFERRAL_COOKIE_NAME },
];
// cookies is an instance of https://www.npmjs.com/package/react-cookie
const handleCookies = (setCookie, search) => {
  const expiresIn = 60 * 60 * 24 * 120; // 120 days
  // RegEx to find value ref value in search string
  refs.forEach(ref => {
    const { re, name } = ref;
    const referrer = search.match(re);
    if (referrer) {
      try {
        localStorage.setItem(name, referrer[1]);
      } catch {
        console.log('local storage not supported');
      }
      setCookie(
        name,
        referrer[1],
        {
          path: '/',
          maxAge: expiresIn,
        },
      );
    }
  })
  
};

export { handleCookies, REFERRAL_COOKIE_NAME, PAP_REFERRAL_COOKIE_NAME };
